<template>
  <div id="UserButtons" class="d-flex w-100 h-100 justify-content-center">
    <ul
        class="tools-container main-nav-items w-100 no-margin no-sm-border list-unstyled flex"
        :class="[ajaxStatusClass, dataStatusClass, userTypeClass, loggedInStatusClass]"
        id="UserButtonsContainer"
    >
      <!-- only show ui if some data is available (local or remote) -->
      <template v-if="dataStatus !== DATA_STATUS_NONE">
        <!-- {% if app.user %} -->
        <!--     {% if app.user.username matches '/^USER_[a-f0-9]{12}$/' or app.user.username matches '/^PDF2GO_[a-f0-9]{12}$/' %} -->
        <!--         {% set displayName = app.user.plainEmail|length > 28 ? app.user.plainEmail|slice(0, 28) ~ '..' : app.user.plainEmail %} -->
        <!--     {% else %} -->
        <!--     {% set displayName = app.user.username|length > 28 ? app.user.username|slice(0, 28) ~ '..' : app.user.username %} -->
        <!-- {% endif %} -->

        <UserButtonsAnonymousView
            v-if="isUserUnregistered"
            :links="links"
            :use-modal-flow="useModalFlow"
            :enable-free-trial="enableFreeTrial"
        ></UserButtonsAnonymousView>

        <UserButtonsRegisteredView
            v-else
            :is-user-eligible-for-free-trial="isUserEligibleForFreeTrial"
            :is-user-premium="isUserPremium"
            :is-user-educational="isUserEducational"
            :is-user-registered="isUserRegistered"
            :is-user-confirmed="isUserConfirmed"
            :user-product="userProduct"
            :user-name="userName"
            :use-modal-flow="useModalFlow"
            :enable-free-trial="enableFreeTrial"
            :free-trial-period="freeTrialPeriod"
            :links="links"
            :user-roles="userRoles"
        ></UserButtonsRegisteredView>
      </template>
    </ul>
  </div>
</template>

<script>
import {satGlobals} from '../../../qaamgo/sat/helper/sat-globals';
import {testIsNonEmptyString, testIsString, testIsTrueish} from '../../../lib/test-and-assert/test-base';
import TransFilter from '../../../qaamgo/modules/sat/components/mixins/TransFilter';
import UserButtonsAnonymousView from './views/UserButtonsAnonymousView';
import UserButtonsRegisteredView from './views/UserButtonsRegisteredView';
import {assertIsString} from '../../../lib/test-and-assert/assert-base';
import {eventBus} from '../../../lib/event-bus/event-bus';
import {userManager} from '../user-manager';

const USER_TYPE_UNREGISTERED = 'unregistered';
const USER_TYPE_REGISTERED = 'registered';
const USER_TYPE_EDUCATIONAL = 'educational';
const USER_TYPE_PREMIUM = 'premium'

const USER_PRODUCT_PREMIUM = 'premium'
const USER_PRODUCT_STARTER = 'starter'
const USER_PRODUCT_PRO = 'pro'
const USER_PRODUCT_ULTIMATE = 'ultimate'

const DATA_STATUS_NONE = 'data_status_none';
const DATA_STATUS_LOCAL = 'data_status_local';
const DATA_STATUS_REMOTE = 'data_status_remote';

const AJAX_STATUS_LOADING = 'ajax_status_loading';
const AJAX_STATUS_SUCCESS = 'ajax_status_success';
const AJAX_STATUS_FAIL = 'ajax_status_fail';

const STORAGE_ID_FOR_ROLES = 'user_buttons_roles';
const STORAGE_ID_FOR_NAME = 'user_buttons_name';
const STORAGE_ID_FOR_TYPE = 'user_buttons_type';
const STORAGE_ID_FOR_PRODUCT = 'user_buttons_product';
const STORAGE_ID_FOR_CONFIRMED = 'user_buttons_confirmed';
const STORAGE_ID_FOR_ELIGIBLE_FOR_FREE_TRIAL = 'user_buttons_eligible_for_free_trial';

/**
 * @param {String} userType
 *
 * @returns {boolean}
 */
function isValidUserType(userType) {
  const isUnregistered = userType === USER_TYPE_UNREGISTERED;
  const isRegistered = userType === USER_TYPE_REGISTERED;
  const isPremium = userType === USER_TYPE_PREMIUM;
  const isEducational = userType === USER_TYPE_EDUCATIONAL;

  return isUnregistered || isRegistered || isPremium || isEducational;
}

/**
 * @param {String} userType
 *
 * @returns {boolean}
 */
function isValidUserProduct(userProduct) {
  const isPremium = userProduct === USER_TYPE_PREMIUM;
  const isStarter = userProduct === USER_PRODUCT_STARTER;
  const isPro = userProduct === USER_PRODUCT_PRO;
  const isUltimate = userProduct === USER_PRODUCT_ULTIMATE;

  return isStarter || isPremium || isPro || isUltimate;
}

/**
 * @param {String} name
 * @param {String} email
 *
 * @return {string}
 */
function generateDisplayName(name, email) {
  assertIsString(name);

  if (name.trim() === '') {
    return '';
  }

  let displayName = name;

  if (testIsNonEmptyString(email)) {
    const reg1 = /^USER_[a-f0-9]{12}$/i;
    const reg2 = /^PDF2GO_[a-f0-9]{12}$/i;

    if (reg1.test(name) || reg2.test(name)) {
      displayName = email;
    }
  }

  if (displayName.length > 23) {
    displayName = displayName.slice(0, 20) + '...';
  }

  return displayName;
}

export default {
  name: 'TheUserButtons',
  components: {UserButtonsRegisteredView, UserButtonsAnonymousView},
  mixins: [TransFilter],
  created() {
    eventBus.listen('user-buttons-clear-localstorage-user', this.clearLocalStorage);
  },
  mounted: function () {
    this.ajaxStatus = AJAX_STATUS_LOADING;
    this.dataStatus = DATA_STATUS_NONE;

    this.loadFromLocalStorage();
    this.getUser();
  },
  computed: {
    dataStatusClass: function () {
      if (this.dataStatus === DATA_STATUS_REMOTE) {
        return 'data-status-remote';
      }

      if (this.dataStatus === DATA_STATUS_LOCAL) {
        return 'data-status-local';
      }

      return 'data-status-none';
    },
    ajaxStatusClass: function () {
      if (this.ajaxStatus === AJAX_STATUS_SUCCESS) {
        return 'ajax-status-success';
      }

      if (this.ajaxStatus === AJAX_STATUS_LOADING) {
        return 'ajax-status-loading';
      }

      return 'ajax-status-fail';
    },
    userTypeClass: function () {
      if (this.dataStatus === DATA_STATUS_NONE) {
        return '';
      }

      if (this.userType === USER_TYPE_PREMIUM) {
        return 'user-type-premium';
      }

      if (this.userType === USER_TYPE_REGISTERED) {
        return 'user-type-registered';
      }

      return 'user-type-unregistered';
    },
    loggedInStatusClass: function () {
      if (this.dataStatus === DATA_STATUS_NONE) {
        return '';
      }

      if (this.userType === USER_TYPE_UNREGISTERED) {
        return 'user-is-not-logged-in border-left';
      }

      return 'user-is-logged-in';
    },
    isUserUnregistered() {
      return this.userType === USER_TYPE_UNREGISTERED;
    },
    isUserRegistered() {
      return this.userType === USER_TYPE_REGISTERED;
    },
    isUserPremium() {
      return this.userType === USER_TYPE_PREMIUM;
    },
    isUserStarter() {
      return this.userProduct === USER_PRODUCT_STARTER
    },
    isUserPro() {
      return this.userProduct === USER_PRODUCT_PRO;
    },
    isUserUltimate() {
      return this.userProduct === USER_PRODUCT_ULTIMATE;
    },
    isUserEducational() {
      return this.userType === USER_TYPE_EDUCATIONAL;
    },
    isUserEligibleForFreeTrial() {
      return this.isEligibleForFreeTrial === true;
    },
    freeTrialPeriod() {
      return satGlobals.getFreeTrialPeriod();
    },
  },
  methods: {
    clearLocalStorage() {
      window.localStorage.removeItem(STORAGE_ID_FOR_ROLES);
      window.localStorage.removeItem(STORAGE_ID_FOR_NAME);
      window.localStorage.removeItem(STORAGE_ID_FOR_TYPE);
      window.localStorage.removeItem(STORAGE_ID_FOR_ELIGIBLE_FOR_FREE_TRIAL);
      window.localStorage.removeItem(STORAGE_ID_FOR_CONFIRMED);
      window.localStorage.removeItem(STORAGE_ID_FOR_PRODUCT);
    },
    loadFromLocalStorage() {
      this.dataStatus = DATA_STATUS_NONE;

      let roles = [];

      try {
        roles = JSON.parse(window.localStorage.getItem(STORAGE_ID_FOR_ROLES));
      } catch (e) {
      }

      try {
        const name = window.localStorage.getItem(STORAGE_ID_FOR_NAME);
        const type = window.localStorage.getItem(STORAGE_ID_FOR_TYPE);
        const product = window.localStorage.getItem(STORAGE_ID_FOR_PRODUCT);
        const isEligibleForFreeTrial = window.localStorage.getItem(STORAGE_ID_FOR_ELIGIBLE_FOR_FREE_TRIAL);

        this.isUserConfirmed = testIsTrueish(window.localStorage.getItem(STORAGE_ID_FOR_CONFIRMED));

        if (!isValidUserType(type) || !testIsString(name)) {
          return;
        }

        if (Array.isArray(roles)) {
          this.userRoles = roles;
        }

        this.userName = name;
        this.userType = type;
        this.isEligibleForFreeTrial = isEligibleForFreeTrial;

        if (type === USER_TYPE_REGISTERED) {
          $('.main-brand-nav').removeClass('hidden');
          $('.claim').addClass('hidden');
        }

        if (isValidUserProduct(product)) {
          this.userProduct = product;
        }

        this.dataStatus = DATA_STATUS_LOCAL;
      } catch (e) {
      }
    },
    async getUser() {
      this.ajaxStatus = AJAX_STATUS_LOADING;

      try {
        const userData = await userManager.getUser();
        this.userRoles = userData?._roles;

        let type = USER_TYPE_UNREGISTERED;
        let product = USER_TYPE_UNREGISTERED;

        if (userData.isRegistered()) {
          type = USER_TYPE_REGISTERED;
        }

        if (userData.isPremium()) {
          type = USER_TYPE_PREMIUM;
          product = USER_TYPE_PREMIUM;
        }

        if (userData.isStarter()) {
          product = USER_PRODUCT_STARTER;
        }

        if (userData.isPro()) {
          product = USER_PRODUCT_PRO;
        }

        if (userData.isUltimate()) {
          product = USER_PRODUCT_ULTIMATE;
        }

        if (userData.isEducational()) {
          type = USER_TYPE_EDUCATIONAL;
        }

        this.isEligibleForFreeTrial = false;

        if (userData.isEligibleForFreeTrial()) {
          this.isEligibleForFreeTrial = true;
        }

        this.isUserConfirmed = testIsTrueish(userData?.isEnabled());

        this.dataStatus = DATA_STATUS_REMOTE;
        this.ajaxStatus = AJAX_STATUS_SUCCESS;

        this.userName = userManager.generateDisplayName(userData._username, userData._plainEmail);
        this.userType = type;
        this.userProduct = product;

        if (type !== USER_TYPE_UNREGISTERED) {
          $('.main-brand-nav').removeClass('hidden');
          $('.claim').addClass('hidden');
        }

        try {
          window.localStorage.setItem(STORAGE_ID_FOR_ROLES, JSON.stringify(this.userRoles));
          window.localStorage.setItem(STORAGE_ID_FOR_NAME, this.userName);
          window.localStorage.setItem(STORAGE_ID_FOR_TYPE, this.userType);
          window.localStorage.setItem(STORAGE_ID_FOR_PRODUCT, this.userProduct);
          window.localStorage.setItem(STORAGE_ID_FOR_CONFIRMED, this.isUserConfirmed);
          window.localStorage.setItem(
              STORAGE_ID_FOR_ELIGIBLE_FOR_FREE_TRIAL,
              this.isEligibleForFreeTrial
          );
        } catch (e) {
        }
      } catch (e) {
        this.ajaxStatus = AJAX_STATUS_FAIL;
      }
    },
  },
  data() {
    return {
      userRoles: [],
      links: window.UserButtonsConfig?.links ?? {},
      dataStatus: DATA_STATUS_NONE,
      ajaxStatus: AJAX_STATUS_LOADING,
      userName: '',
      userType: USER_TYPE_UNREGISTERED,
      userProduct: USER_TYPE_UNREGISTERED,
      isEligibleForFreeTrial: false,
      isUserConfirmed: false,
      DATA_STATUS_NONE: DATA_STATUS_NONE,
      DATA_STATUS_LOCAL: DATA_STATUS_LOCAL,
      DATA_STATUS_REMOTE: DATA_STATUS_REMOTE,
      AJAX_STATUS_LOADING: AJAX_STATUS_LOADING,
      AJAX_STATUS_SUCCESS: AJAX_STATUS_SUCCESS,
      AJAX_STATUS_FAIL: AJAX_STATUS_FAIL,
      USER_TYPE_UNREGISTERED: USER_TYPE_UNREGISTERED,
      USER_TYPE_REGISTERED: USER_TYPE_REGISTERED,
      USER_TYPE_PREMIUM: USER_TYPE_PREMIUM,
      useModalFlow: satGlobals.getEnableUserModalFlow(),
      enableFreeTrial: satGlobals.getEnableFreeTrial(),
      logoutStarted: false,
    };
  },
};
</script>
